export default function NuovoProgetto() {

  function handlerChange(e) {
    if (e.target.files[0]) {
      // e.target.file[0];
      //setImage(e.target.files[0]);
      console.log(e.target.files);
    }
    //
  }

  return(
    <div className={"container"}>
      <h1>Nuovo Progetto</h1>
      <label>Nome Progetto</label>
      <input type="text" />
      <label>Informazioni progetto</label>
      <textarea></textarea>
      <input className={"nuovaFoto"} type="file" multiple onChange={handlerChange}/>
      <button>Crea progetto</button>
    </div>
  )
}
